'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Section": "Polaris-Menu-Message__Section"
};

exports.default = styles;
